import React from 'react';
import { FormattedMessage } from 'react-intl';

import { SearchResultMoreWrapper } from '../LiveSearchElementStructure.tsx';
import { i18n } from '../i18n.tsx';

interface SearchResultMoreProps {
	onClick: ({ searchMore }: { searchMore: string }) => void;
	searchInput: string;
}

export const SearchResultMore = ({
	onClick,
	searchInput,
}: SearchResultMoreProps): React.JSX.Element => (
	<SearchResultMoreWrapper onClick={() => onClick({ searchMore: searchInput })}>
		<FormattedMessage {...i18n.liveSearchSelectSearchMore} />
	</SearchResultMoreWrapper>
);
